import { actionCreator, createTypes } from 'redux-action-creator';

export const types = createTypes(['ADD', 'REMOVE', 'DETAIL'])

export const actions = {
  addAlert: actionCreator(types.ADD, 'showAlert'),
  removeAlert: actionCreator(types.REMOVE, 'showAlert'),
  detailAlert: actionCreator(types.DETAIL,  'severity', 'message', 'time' )
}

export default { types, actions }
